import { useEffect } from 'react';

export const useCookieConsent = (enabled: boolean): void => {
  useEffect(() => {
    if (!enabled) return;

    import('vanilla-cookieconsent').then(module => {
      const CookieConsent = module.default || module;
      CookieConsent.run({
        categories: {
          necessary: {
            enabled: true,
            readOnly: true
          },
          analytics: {
            enabled: false
          }
        },
        language: {
          default: 'en',
          translations: {
            en: {
              consentModal: {
                title: 'We use cookies',
                description: 'We use cookies to enhance your browsing experience and analyze our traffic.',
                acceptAllBtn: 'Accept All',
                acceptNecessaryBtn: 'Reject All'
              },
              preferencesModal: {
                title: 'Preferences',
                acceptAllBtn: 'Accept All',
                acceptNecessaryBtn: 'Reject All',
                savePreferencesBtn: 'Save',
                sections: []
              }
            }
          }
        },
        onConsent: ({ cookie }) => {
          if (Array.isArray(cookie.categories) && cookie.categories.includes('analytics')) {
            window.gtag?.('consent', 'update', {
              analytics_storage: 'granted',
              ad_storage: 'denied'
            });
          }
        }
      });
    });
  }, [ enabled ]);
};
